import React from "react";
import {generateUniqueID} from "web-vitals/dist/modules/lib/generateUniqueID";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";

import ServicesEn from './components/services/services-en';
import ServicesRu from './components/services/services-ru';
import ServicesCn from './components/services/services-cn';
import ServicesTargetRu from "./components/services/services-target-ru";
import ServicesTargetEn from "./components/services/services-target-en";
import Category from './components/category/category';
import CategoryTarget from "./components/category/category-target";
import ProjectsEn from '../src/data/projects-en.json';
import ProjectsRu from '../src/data/projects-ru.json';
import ProjectsCn from '../src/data/projects-cn.json';
import ProjectsTargetRu from  '../src/data/projects-target-ru.json';
import ProjectsTargetEn from  '../src/data/projects-target-en.json';
import ContactsScrollButton from './components/contacts-scroll-button/contacts-scroll-button';

function App() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const cn = params.lang && (params.lang === 'cn');
  const eng = (window.lang && window.lang === 'en') || (params.lang === 'en');

  const projects = eng ? ProjectsEn : cn ? ProjectsCn : ProjectsRu;
  const targetProjects = eng ? ProjectsTargetEn : ProjectsTargetRu;
  const services = eng ? ServicesEn : cn ? ServicesCn : ServicesRu;
  const targetServices = eng ? ServicesTargetEn : ServicesTargetRu;

  return (
      <>
        <ContactsScrollButton/>
        <Router>
          <Switch>
            <Route exact path="/competencies" component={services}/>
            <Route exact path="/competencies/target" component={targetServices}/>
            
            {/* Компетенции: Что мы делаем */}
            {
              Object.entries(projects).map(project => {
                const tag = project[0];
                return (
                  <Route exact key={generateUniqueID()} path={"/competencies/" + tag}>
                    <Category tag={tag} />
                  </Route>
                );
              })
            }

            {/* Компетенции: Для кого */}
            {
              Object.entries(targetProjects).map(project => {
                const tag = project[0];
                return (
                  <Route exact key={generateUniqueID()} path={"/competencies/target/" + tag}>
                    <CategoryTarget tag={tag} />
                  </Route>
                );
              })
            }
          </Switch>
        </Router>
      </>
  );
}

export default App;
